module.exports = __webpack_public_path__ + "static/media/word_search.e99173a0.jpg";